import React from 'react';
import {connect} from "react-redux";
import {compose} from "redux";
import {translate} from "react-i18next";
import Call from "../../../hocs/call";
import { changeSetPermissionsCatSchemesPermissions, readSetPermissionsCategorySchemes} from "./actions";
import {getLocalizedStr} from "../../../middlewares/i18n/utils";
import {Button, Col, Icon, Row} from "antd";
import {GUTTER_SM} from "../../../styles/constants";
import InfiniteScrollTable from '../../../components/infinite-scroll-table';
import { getStringFromArtefactTriplet } from '../../../utils/sdmxJson';

const IconFontCNIcon = Icon.createFromIconfontCN({
  scriptUrl: './static/vendor/iconfont_cn/iconfont.js',
});

const mapStateToProps = state => ({
  appLanguage: state.app.language,
  dataLanguages: state.config.dataManagement.dataLanguages,
  categorySchemes: state.scenes.manageUsers.setPermissions.categorySchemes,
  permissions: state.scenes.manageUsers.setPermissions.permissions
});

const mapDispatchToProps = dispatch => ({
  onChange: catSchemesPermissions => dispatch(changeSetPermissionsCatSchemesPermissions(catSchemesPermissions)),
  fetchCategorySchemes: () => dispatch(readSetPermissionsCategorySchemes())
});


const SetPermissionsCatSchemes = ({
                               t,
                               appLanguage,
                               dataLanguages,
                               permissions,
                               categorySchemes,
                               onChange,
                               fetchCategorySchemes
                             }) => {

  const allCatSchemes = (categorySchemes || [])
    .map(categoryScheme => getStringFromArtefactTriplet(categoryScheme) );  

  return (
    <Call cb={fetchCategorySchemes}>
      {categorySchemes && (
      <InfiniteScrollTable
        showHeader={false}
        height={284}
        data={    
          categorySchemes.map(categoryScheme => {
            const id = getStringFromArtefactTriplet(categoryScheme);
            const name = getLocalizedStr(categoryScheme.names, appLanguage, dataLanguages);
            const label = `[${id}] ${name}`;
            return ({
              id: id,
              label: label
            })
          })               
        }
        getRowKey={({id}) => id}
        columns={[
          {
            dataIndex: 'label',
            minWidht: 150,
            render: label => 
                      <span>
                        <IconFontCNIcon type="database"/> {label}
                      </span>
          }
        ]}
        rowSelection={{
          selectedRowKeys: permissions ? permissions.categoryScheme : [],
          onChange
        }}
        rightActions={
          <Row type="flex" gutter={GUTTER_SM}>
            <Col>
              <Button onClick={() => onChange(allCatSchemes)} type="primary">
                {t('commons.buttons.selectAll.title')}
              </Button>
            </Col>
            <Col>
              <Button onClick={() => onChange([])}>
                {t('commons.buttons.deselectAll.title')}
              </Button>
            </Col>
          </Row>
        }
      />
    )}
    </Call>
  )
};

export default compose(
  translate(),
  connect(mapStateToProps, mapDispatchToProps)
)(SetPermissionsCatSchemes);
